import { Intent } from 'signup-constants/Intent';
import { getHublet } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
import { isIntent } from '../utils/isIntent';
import { TrialId } from '../trial/trialConstants';
import { trial } from '../intents/intentLinks';
export const getAeoStandaloneRedirect = state => {
  const portalId = getPortalId(state);
  const hublet = getHublet(state);
  return trial(portalId, hublet, {
    trialId: TrialId.AeoStandalone.toString()
  });
};
export const createAeoStandaloneRedirect = () => {
  // When intent=purchase is present on the AEO flow, bypass the AEO-specific
  // redirect so the generic intent system handles the redirect to /purchase/{portalId}
  return isIntent(Intent.purchase) ? undefined : getAeoStandaloneRedirect;
};